import actions from '../constants';

const initialState = {
  benefits: {},
  selectedBenefit: 0
};

const benefits = function(state = initialState, action) {
  switch(action.type) {
    case actions.FETCH_BENEFITS:
      return {
        ...state,
        benefits: action.benefits
      };
    default:
      return state;
  }
};

export default benefits;



// WEBPACK FOOTER //
// ./src/advocate/onboarding/reducers/benefits.js